import React, { Component } from 'react';
import { BASE } from '../api/api'
import cachios from 'cachios'
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import './archive.css'
import ArchiveDesc from './archivedesc';
import ArchiveCont from './archivecont';


class Archive extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cluster: '',
            project: '',
            objarr: [],
            checkarr: [],
            filter: ''
        }

    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    color(type, value) {
        let dt = this.state.checkarr.indexOf(type + ':' + value)
        if (dt > -1) {
            return true
        }
        else
            return false
    }
    setfilter(type, value) {
        let object = {}
        let orgfilter = []
        let evefilter = []
        let checkarr = this.state.checkarr
        object[type] = value
        let objarr = this.state.objarr
        let dt = checkarr.indexOf(type + ':' + value)
        if (dt > -1) {
            checkarr.splice(dt, 1);
            objarr.splice(dt, 1);
        }
        else {
            checkarr.push(type + ':' + value)
            objarr.push(object)
        }
        console.log(object, objarr, 'test')
        this.setState({
            objarr: objarr,
            checkarr: checkarr
        })
        let index = 0
        let filter = []
        objarr.map((object1, ind) => {
            for (var i in object1) {
                if (orgfilter.indexOf(i) === -1) {
                    orgfilter.push(i) // alerts key
                    filter.push('event[B' + index + ']=organizer:' + i)
                    index++
                }
                if (evefilter.indexOf(object1[i]) === -1) {
                    evefilter.push(object1[i]); //alerts key's value
                    filter.push('event[B' + index + ']=event_type:' + object1[i])
                    index++
                }
            }
        })
        this.setState({
            filter: filter.join('&')
        })
    }
    componentWillMount() {
        this.description();
        this.archivefilter();
        this.topFunction();
    }


    //outer descriptiom
    description() {
        cachios.get(BASE + 'jsonapi/block_content/basic?include=field_image', {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                console.log(data.data.data, 'desc')

                this.setState({
                    desc: data.data.data,
                    descimg: data.data.included[0]
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }

    //filter
    archivefilter() {
        cachios.get(BASE + 'api/archives_filter_list', {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                console.log(data.data, 'desc')
                this.setState({
                    mainfilter: data.data.data.organizer,
                    subfilter: data.data.data.event_types
                })

            })
            .catch((err) => {
                console.log('not found')
            })
    }

    render() {
        return (
            <div className='searchpage archive_page project_page'>

                <div className="main-content listing">
                    <div className="newsrea" style={{ width: '100%' }}>
                        <div className="row">

                            <div className="region region-content search_inner_container">

                                <div className="filter_block">
                                    <div className="filter_container">

                                        {this.state.subfilter ?
                                            this.state.mainfilter.sort((a, b) => parseFloat(a.field_sort_order) - parseFloat(b.field_sort_order)).map((main, mainind) => {
                                                if(main.organizer_value==='CIS archives')
                                                return <div className="filter_inner_wrapper">
                                                    <div>
                                                        <div className="filter_inner_wrpr">
                                                            
                                                                        {this.state.subfilter ? this.state.subfilter.map((val_arr, ind) => {
                                                                            if (main.organizer_value === "LSE/SOAS archives"   && val_arr.event_type_value === "Forums" || (val_arr.event_type_value === "Lectures/Seminars" || val_arr.event_type_value === "Reports")){
                                                                                return null
                                                                            }
                                                                            else {
                                                                                if (val_arr.event_type_value)
                                                                                    return (<div className="selct_container" >
                                                                                        <div className="selct_box" style={{ background: this.color(main.organizer_key, val_arr.event_type_key) ? '#165E84' : '' }} onClick={() => this.setfilter(main.organizer_key, val_arr.event_type_key)} ></div>
                                                                                        <div className="selct_value" onClick={() => this.setfilter(main.organizer_key, val_arr.event_type_key)} >{main.organizer_value === "CIS archives" && val_arr.event_type_value === "Forums" ? "Conferences" : val_arr.event_type_value}</div>
                                                                                    </div>)
                                                                            }

                                                                        }) : ''}
                                                        </div>

                                                    </div>

                                                </div>
                                            })

                                            : ''}


                                    </div>



                                </div>



                                <div className="search_block">

                                    {this.state.filter ? <ArchiveCont filter={this.state.filter} /> : <ArchiveDesc />}

                                </div>



                            </div>
                        </div>
                    </div>
                </div>

                <div class="button-responsive">
                    <button onClick={() => this.setState({
                        fpopup: !this.state.fpopup
                    })} class="filter">Filter</button>
                    <i class="filter-icon"></i>
                </div>
                {/* MObile FIlter */}
                <div className='mobile_filter' style={{ display: this.state.fpopup ? '' : 'none' }}>
                    <div className='mobile_filter_head' ><div>Filters</div><div onClick={() => this.setState({
                        fpopup: !this.state.fpopup
                    })}>X</div></div>
                    <div className="filter_block">
                        <div className="filter_container">

                            {this.state.subfilter ?
                                this.state.mainfilter.map((main, mainind) => {
                                    return <div className="filter_inner_wrapper">
                                        <div>

                                            <div className="filter_inner_wrpr">
                                                <Accordion>
                                                    <AccordionItem expanded={mainind === 0 ? true : false}>
                                                        <AccordionItemTitle className='accordion__title'>
                                                            <div className='sub'>
                                                                <div className='card-title'>{main.organizer_value}</div>
                                                                <div class="accordion__arrow" role="presentation"></div>
                                                            </div>
                                                        </AccordionItemTitle>
                                                        <AccordionItemBody>
                                                            {this.state.subfilter ? this.state.subfilter.map((val_arr, ind) => {
                                                                return (<div className="selct_container" >
                                                                    <div className="selct_box" style={{ background: this.color(main.organizer_key, val_arr.event_type_key) ? '#165E84' : '' }} onClick={() => this.setfilter(main.organizer_key, val_arr.event_type_key)} ></div>
                                                                    <div className="selct_value" onClick={() => this.setfilter(main.organizer_key, val_arr.event_type_key)} >{val_arr.event_type_value}</div>
                                                                </div>)
                                                            }) : ''}
                                                        </AccordionItemBody>
                                                    </AccordionItem>
                                                </Accordion>
                                            </div>

                                        </div>

                                    </div>
                                })

                                : ''}


                            <div class="button-responsive">
                                <button onClick={() => this.setState({
                                    fpopup: !this.state.fpopup
                                })} class="filter">Apply Filter</button>
                                <i class="filter-icon"></i>
                            </div>

                        </div>



                    </div>

                </div>
            </div>

        )


    }

}


export default Archive;
